












import { Component, mixins } from 'nuxt-property-decorator'
import { defineComponent } from '@nuxtjs/composition-api'
import { SectionCore } from '@/mixins/sectionCore'
import SectionBasic from '@/components/SectionBasic.vue'
import BlockBannerText from '@/components/BlockBannerText.vue'

@Component
class SectionBlockBannerText extends mixins(SectionCore) {}

export default defineComponent({
  name: 'SectionBlockText',
  components: { SectionBasic, BlockBannerText },
  props: SectionBlockBannerText.options.props,
  setup() {},
})
